/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CertPinDTO
 */
export interface CertPinDTO {
    /**
     * 
     * @type {string}
     * @memberof CertPinDTO
     */
    subject?: string;
    /**
     * 
     * @type {string}
     * @memberof CertPinDTO
     */
    notAfter?: string;
    /**
     * 
     * @type {string}
     * @memberof CertPinDTO
     */
    lastUsed?: string;
    /**
     * 
     * @type {string}
     * @memberof CertPinDTO
     */
    sha256Thumbprint?: string;
}

export function CertPinDTOFromJSON(json: any): CertPinDTO {
    return CertPinDTOFromJSONTyped(json, false);
}

export function CertPinDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CertPinDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'subject': !exists(json, 'subject') ? undefined : json['subject'],
        'notAfter': !exists(json, 'notAfter') ? undefined : json['notAfter'],
        'lastUsed': !exists(json, 'lastUsed') ? undefined : json['lastUsed'],
        'sha256Thumbprint': !exists(json, 'sha256Thumbprint') ? undefined : json['sha256Thumbprint'],
    };
}

export function CertPinDTOToJSON(value?: CertPinDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'subject': value.subject,
        'notAfter': value.notAfter,
        'lastUsed': value.lastUsed,
        'sha256Thumbprint': value.sha256Thumbprint,
    };
}

